<template>
	<v-card 
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>

		<v-card-text>
			{{ text }}
		</v-card-text>

		<v-card-text>
			<v-icon color="primary" icon="mdi-thumb-up" size="150"></v-icon>
		</v-card-text>

		<v-card-text class="text-left">
			<v-form ref="form">
				<h4 class="my-3">Після опрацювання документів Вам надійде смс підтверждення.</h4>
				<!-- <h4 class="my-3">Чекаємо від Вас оригінали заяв та завірені копії документів</h4>
				<h4 class="my-3">Реквізити для відправки:</h4> -->
				<h4 class="my-3">Оригінали документів необхідно надіслати:</h4>
				<p class="my-3">Укрпошта<br>01032, м. Київ. вул. Саксаганського. 96<br>Отримувач: ТДВ «СК «ГАРДАН»</p>
				<p class="my-3">Нова Пошта<br>м. Київ, відділення №214<br>Отримувач: ТДВ «СК «ГАРДІАН»<br>067 188 81 98 (Сіденко Сергій Петрович)<br>Оплата доставки — за рахунок відправника</p>
				<h4 class="my-3">У разі виникнення питань щодо роботи вебсторінки, будь ласка, телефонуйте в робочі години страхової компанії «Гардіан» з 09:00 до 18.00 нa 0 800 503 114.</h4>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import mixin from './mixin/main'

export default {
	mixins: [mixin],
}
</script>
